import { render, staticRenderFns } from "./game-category.vue?vue&type=template&id=4a73478b&"
import script from "./game-category.vue?vue&type=script&lang=js&"
export * from "./game-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports